/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconArrowRight8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowRight8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                d="m2.22 6.47 2.592-2.595L2.219 1.28A.75.75 0 0 1 3.281.22l3.122 3.125a.75.75 0 0 1 0 1.06L3.28 7.53a.75.75 0 0 1-1.062-1.06Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconArrowRight12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowRight12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                d="m3.22 9.57 3.592-3.595L3.219 2.38a.75.75 0 0 1 1.062-1.06l4.122 4.125a.75.75 0 0 1 0 1.06L4.28 10.63a.75.75 0 1 1-1.062-1.06Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconArrowRight16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowRight16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M4.793 12.793 9.583 8l-4.79-4.793a1 1 0 0 1 1.414-1.414l5.497 5.5a1 1 0 0 1 0 1.414l-5.497 5.5a1 1 0 0 1-1.414-1.414Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconArrowRight20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowRight20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                d="M6.503 4.707a1 1 0 0 1 1.414-1.414l5.646 5.646a1.5 1.5 0 0 1 0 2.122l-5.646 5.646a1 1 0 0 1-1.414-1.414L11.796 10 6.503 4.707Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconArrowRight24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowRight24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M8.293 5.707a1 1 0 0 1 1.414-1.414l6.647 6.646a1.5 1.5 0 0 1 0 2.122l-6.647 6.646a1 1 0 0 1-1.414-1.414L14.586 12 8.293 5.707Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconArrowRight = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowRight(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconArrowRight8 {...iconProps} />;
        case '12':
            return <IconArrowRight12 {...iconProps} />;
        case '16':
            return <IconArrowRight16 {...iconProps} />;
        case '20':
            return <IconArrowRight20 {...iconProps} />;
        case '24':
            return <IconArrowRight24 {...iconProps} />;
        default:
            return <IconArrowRight24 {...iconProps} />;
    }
});
